var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      model: _vm.form,
      "label-width": "150px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "角色信息："
    }
  }, [_c("span", {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" 角色ID：")]), _c("span", {
    staticStyle: {
      color: "#409EFF",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.form.role_id))]), _vm._v("     "), _c("span", {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("角色名：")]), _c("span", {
    staticStyle: {
      color: "#409EFF",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.form.role_name))])]), _c("el-form-item", {
    attrs: {
      label: "建议内容："
    }
  }, [_c("div", {
    staticClass: "adviceClass"
  }, [_vm._v(" " + _vm._s(_vm.form.suggest_content) + " ")])]), _c("el-form-item", {
    attrs: {
      label: "建议时间："
    }
  }, [_vm._v(" " + _vm._s(_vm.form.suggest_time) + " ")]), _vm.form.reply_status === 3 ? _c("el-form-item", {
    attrs: {
      label: "历史回复："
    }
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.form.replyMsg,
      "cell-class-name": _vm.cellStyle,
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266",
        fontWeight: "bold"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "回复内容",
      prop: "reply_content"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "account",
      label: "回复用户+时间",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          staticStyle: {
            color: "#409EFF"
          }
        }, [_vm._v(" 回复用户：" + _vm._s(scope.row.reply_user) + " ")]), _vm._v(" " + _vm._s(scope.row.reply_time) + " ")];
      }
    }], null, false, 563558223)
  })], 1)], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "是否回复："
    }
  }, [_c("el-switch", {
    attrs: {
      "active-text": "回复",
      "inactive-text": "忽略"
    },
    model: {
      value: _vm.status,
      callback: function callback($$v) {
        _vm.status = $$v;
      },
      expression: "status"
    }
  })], 1), _vm.status == true ? _c("el-form-item", {
    attrs: {
      label: _vm.form.isReply === 3 ? "再次回复：" : "填写回复："
    }
  }, [_c("el-input", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.replyInput,
      callback: function callback($$v) {
        _vm.replyInput = $$v;
      },
      expression: "replyInput"
    }
  })], 1) : _vm._e()], 1), _c("div", {
    staticClass: "footerClass",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        return _vm.cancelBtn();
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.confirmBtn();
      }
    }
  }, [_vm._v("确 定")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };